import classNames from 'classnames'

import Adhesion from '@/components/Layout/Adhesion/Adhesion'
import Leaderboard from '@/components/Layout/Leaderboard/Leaderboard'
import Sidebar from '@/components/Layout/Sidebar/Sidebar'
import { useTheme } from '@/components/ThemeProvider/ThemeProvider'
import VideoAd from '@/components/VideoAd/VideoAd'
import { useAds } from '@/contexts/ads'
import useDirectories from '@/utils/useDirectories'

import styles from './Main.module.scss'

const GRADIENT_DARK = 'linear-gradient(to bottom, rgba(18, 19, 21, 0.5), rgba(18, 19, 21, 1))'
const GRADIENT_LIGHT = 'linear-gradient(to bottom, rgba(249, 250, 251, 0.5), rgba(249, 250, 251, 1))'

const LEADERBOARD_BLACKLIST = ['annamargaret', 'combo-vote']
const SIDEBAR_BLACKLIST = [
  'about-us',
  'account',
  'annamargaret',
  'apply',
  'bug-report',
  'confirm-password',
  'contact-us',
  'forgot-password',
  'newsletter',
  'privacy',
  'reset-password',
  'signin',
  'signup',
]
const ADHESION_WHITELIST = ['', ...SIDEBAR_BLACKLIST, 'articles']
const VIDEO_AD_ENABLED = false

type Props = {
  artCrop?: string
  banner?: React.ReactNode
  children: React.ReactNode
  isGuide?: boolean
}

const Main = ({ artCrop, banner, children, isGuide }: Props) => {
  const { country, loadAds } = useAds()
  const { dir } = useDirectories()
  const [theme] = useTheme()

  const gradient = theme === 'dark' ? GRADIENT_DARK : GRADIENT_LIGHT
  const showAdhesion = loadAds !== false && ADHESION_WHITELIST.includes(dir)
  const showLeaderboard = loadAds !== false && !LEADERBOARD_BLACKLIST.includes(dir)
  const showSidebar = loadAds !== false && !SIDEBAR_BLACKLIST.includes(dir)

  return (
    <>
      {artCrop && (
        <div className={styles.backgroundContainer}>
          <div
            className={styles.background}
            style={{
              backgroundImage: `${gradient}, url(${artCrop})`,
            }}
          />
        </div>
      )}
      {banner && <div className={styles.backgroundContainer}>{banner}</div>}
      {country === 'MX' && (
        <div
          data-blocklist-adhesion-desktop='1'
          data-blocklist-adhesion-mobile='1'
          data-blocklist-adhesion-tablet='1'
          data-blocklist-universal-player-desktop='1'
          data-blocklist-universal-player-mobile='1'
          id='mediavine-settings'
        />
      )}
      {VIDEO_AD_ENABLED && (
        <div
          data-blocklist-universal-player-desktop='1'
          data-blocklist-universal-player-mobile='1'
          id='mediavine-settings'
        />
      )}
      <main className={styles.main}>
        {showLeaderboard && <Leaderboard />}
        <div className={classNames('d-flex flex-grow-1 p-3', { 'pe-lg-0': showSidebar })}>
          <div className='d-flex w-100'>
            <div className={showSidebar ? styles.left : 'w-100'}>{children}</div>
            {showSidebar && <Sidebar country={country} isGuide={isGuide} />}
          </div>
        </div>
      </main>
      {VIDEO_AD_ENABLED && loadAds && <VideoAd showingAdhesion={showAdhesion} />}
      {(country === 'MX' || process.env.NODE_ENV !== 'production') && <Adhesion enableDesktop={showAdhesion} />}
    </>
  )
}

export default Main
